import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const contractTiers = (state = initialState.contractTiers, action) => {
  switch (action.type) {
    case types.LOAD_CONTRACT_TIER_SUCCESS:
      return action.contractTiers;

    case types.CREATE_CONTRACT_TIER_SUCCESS:
      return [...state, { ...action.contractTier }];

    case types.UPDATE_CONTRACT_TIER_SUCCESS:
      return [
        ...state.filter((c) => c.id !== action.contractTier.id),
        { ...action.contractTier }
      ];

    default:
      return state;
  }
};

export const contractTier = (state = initialState.contractTier, action) => {
  switch (action.type) {
    case types.GET_CONTRACT_TIER_SUCCESS:
      return action.contractTier;

    default:
      return state;
  }
};

export const savingContractTier = (
  state = initialState.savingContractTier,
  action
) => {
  switch (action.type) {
    case types.SAVING_CONTRACT_TIER:
      return action.savingContractTier;

    default:
      return state;
  }
};
